module.exports = __webpack_public_path__ + "static/media/39-iveco.1c29ffbb.jpg";